document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.custom-bundle-builder');
  if (!container) return;

  const CONFIG = {
    productId: container.dataset.productId,
    sectionId: document.querySelector('.custom-bundle-section').dataset.sectionId
  };

  // State
  let state = {
    packSize: 3, // Default
    selectedSize: null, // e.g., 'M'
    slots: [], // Array of { color: 'Black', variantId: 123, image: 'url' }
    variants: []
  };

  // Elements
  const els = {
    jsonScript: document.getElementById(`BundleProductJson-${CONFIG.sectionId}`),
    sizeBtns: container.querySelectorAll('.bundle-size-btn'),
    productSizeInputs: container.querySelectorAll('input[name="bundle-size"]'),
    slotsContainer: document.getElementById('bundle-slots'),
    colorSwatches: container.querySelectorAll('.color-swatch-item'),
    totalPriceDisplay: document.getElementById('bundle-total-price'),
    comparePriceDisplay: document.getElementById('bundle-compare-price'),
    addToCartBtn: document.getElementById('add-bundle-to-cart'),
    errorMessage: document.getElementById('bundle-error-message'),
    modal: document.getElementById('custom-bundle-modal'),
    openModalBtns: document.querySelectorAll('.open-bundle-builder-trigger, #open-bundle-builder'), // Support both class and ID
    closeModalBtn: document.getElementById('close-bundle-modal'),
    modalOverlay: document.querySelector('.custom-bundle-modal-overlay')
  };

  // Init
  function init() {
    console.log('[Custom Bundle] Init started');

    // Bind separate modal events first, so popup always works
    bindModalEvents();

    if (!container) {
      console.warn('[Custom Bundle] Container .custom-bundle-builder not found. Modal will be empty or show default message.');
      return;
    }

    if (els.jsonScript) {
      console.log('[Custom Bundle] JSON data found');
      const productData = JSON.parse(els.jsonScript.textContent);
      if (productData) {
        state.variants = productData.variants || [];
        state.bundleSizes = (productData.bundleSizes || []).map(s => parseInt(s.trim()));
        state.bundleDiscounts = (productData.bundleDiscounts || []).map(d => {
          const val = d.trim();
          if (val.startsWith('$')) {
            const numericPart = val.replace('$', '').trim();
            return { type: 'fixed', value: parseFloat(numericPart) * 100 };
          }
          return { type: 'percentage', value: parseFloat(val) / 100 };
        });
        console.log('[Custom Bundle] Loaded variants:', state.variants.length);
        console.log('[Custom Bundle] Loaded discounts:', state.bundleDiscounts);
      }
    }

    // Set initial pack size logic
    const activeSizeBtn = container.querySelector('.bundle-size-btn.active');
    if (activeSizeBtn) {
      updatePackSize(parseInt(activeSizeBtn.dataset.size));
    } else if (els.sizeBtns.length > 0) {
      updatePackSize(parseInt(els.sizeBtns[0].dataset.size));
    }

    // Set initial product size logic
    const checkedSizeInput = container.querySelector('input[name="bundle-size"]:checked');
    if (checkedSizeInput) {
      state.selectedSize = checkedSizeInput.value;
    }

    // Update Trigger Buttons Text if specified
    const triggerText = container.closest('.custom-bundle-section').dataset.triggerText;
    if (triggerText && els.openModalBtns.length > 0) {
      els.openModalBtns.forEach(btn => {
        btn.textContent = triggerText;
      });
      console.log('[Custom Bundle] Updated trigger buttons text:', triggerText);
    }

    bindBuilderEvents();
    renderSlots();
    updateVariantAvailability();
    // If default selected size is out of stock, select first available size
    const checkedInput = container.querySelector('input[name="bundle-size"]:checked');
    if (checkedInput && checkedInput.disabled) {
      const firstAvailable = container.querySelector('input[name="bundle-size"]:not(:disabled)');
      if (firstAvailable) {
        firstAvailable.checked = true;
        state.selectedSize = firstAvailable.value;
        updateVariantAvailability();
      }
    }
    updateUI();
  }

  function bindModalEvents() {
    if (els.openModalBtns && els.openModalBtns.length > 0) {
      els.openModalBtns.forEach(btn => {
        btn.addEventListener('click', openModal);
      });
      console.log(`[Custom Bundle] Bound click to ${els.openModalBtns.length} trigger buttons`);
    } else {
      console.warn('[Custom Bundle] No trigger buttons found (checked .open-bundle-builder-trigger and #open-bundle-builder).');
    }

    if (els.closeModalBtn) els.closeModalBtn.addEventListener('click', closeModal);
    if (els.modalOverlay) els.modalOverlay.addEventListener('click', closeModal);
  }

  function bindBuilderEvents() {
    // Pack Size Click
    els.sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        els.sizeBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updatePackSize(parseInt(btn.dataset.size));
      });
    });

    // Product Size Change
    els.productSizeInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        if (input.disabled) return;
        state.selectedSize = e.target.value;
        updateVariantAvailability(); // Update color swatches for new size
        updateUI();
      });
    });

    // Color Swatch Click (skip if out-of-stock)
    els.colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        if (swatch.classList.contains('out-of-stock')) return;
        const color = swatch.dataset.color;
        const image = swatch.dataset.image;
        addColorToSlot(color, image);
      });
    });

    // Slot Click (Remove)
    els.slotsContainer.addEventListener('click', (e) => {
      const slot = e.target.closest('.bundle-slot.filled');
      if (slot) {
        const index = parseInt(slot.dataset.index);
        removeSlot(index);
      }
    });

    // Add to Cart
    els.addToCartBtn.addEventListener('click', addToCart);
  }

  function openModal() {
    els.modal.classList.add('open');
    document
      .querySelector(".custom-bundle-section")
      .classList.add("active");
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  function closeModal() {
    document
      .querySelector(".custom-bundle-section")
      .classList.remove("active");
    els.modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updatePackSize(size) {
    state.packSize = size;
    // Resize slots array. Use 0-filled or truncate
    const newSlots = new Array(size).fill(null);
    // Copy existing filled slots over if possible
    state.slots.forEach((s, i) => {
      if (i < size) newSlots[i] = s;
    });
    state.slots = newSlots;
    renderSlots();
    updateUI();
  }

  function addColorToSlot(color, image) {
    // Find first empty slot
    const emptyIndex = state.slots.findIndex(s => s === null);
    if (emptyIndex === -1) {
      // Full, maybe replace the last one or notify user? 
      // Reference behavior: usually overwrite last or do nothing.
      // Let's replace the last one for now, or do nothing? 
      // Better UX: Shake the slots or show message "Pack is full"
      return;
    }

    // Find variant for this Color + Selected Size
    const variant = findVariant(state.selectedSize, color);

    if (!variant) {
      console.warn('Variant not found for', state.selectedSize, color);
      // Maybe visually disable swatches that aren't available?
      return;
    }

    if (!variant.available) return;

    state.slots[emptyIndex] = {
      color: color,
      image: image,
      size: state.selectedSize,
      variantId: variant.id,
      price: variant.price
    };

    renderSlots();
    updateUI();
  }

  function removeSlot(index) {
    state.slots[index] = null;
    renderSlots();
    updateUI();
  }

  function updateSlotVariantIds() {
    // Re-check all filled slots against the new size
    state.slots = state.slots.map(slot => {
      if (!slot) return null;
      const variant = findVariant(state.selectedSize, slot.color);
      if (variant && variant.available) {
        return { ...slot, variantId: variant.id, price: variant.price };
      } else {
        // Option A: Keep it but mark invalid?
        // Option B: Remove it?
        // Let's remove it if invalid size combo
        return null;
      }
    });
    renderSlots();
  }

  function findVariant(size, color) {
    return state.variants.find(v => {
      // Logic assumes options are Size and Color. 
      // Option order can vary.
      return (v.option1 === size || v.option2 === size || v.option3 === size) &&
        (v.option1 === color || v.option2 === color || v.option3 === color);
    });
  }

  /** Check if any variant with this size is available (any color). */
  function isSizeAvailable(size) {
    return state.variants.some(v => {
      const hasSize = v.option1 === size || v.option2 === size || v.option3 === size;
      return hasSize && v.available;
    });
  }

  /** Update which size options and color swatches are disabled based on inventory. */
  function updateVariantAvailability() {
    if (!state.variants || state.variants.length === 0) return;

    // Step 2: Size options – disable sizes with no available variant (any color)
    els.productSizeInputs.forEach(input => {
      const sizeValue = input.value;
      const label = input.closest('.size-option');
      const available = isSizeAvailable(sizeValue);
      if (label) {
        label.classList.toggle('out-of-stock', !available);
      }
      input.disabled = !available;
    });

    // Step 3: Color swatches – disable colors that are out of stock for selected size
    const selectedSize = state.selectedSize;
    els.colorSwatches.forEach(swatch => {
      const color = swatch.dataset.color;
      const variant = findVariant(selectedSize, color);
      const available = variant && variant.available;
      swatch.classList.toggle('out-of-stock', !available);
      swatch.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function renderSlots() {
    els.slotsContainer.innerHTML = '';
    state.slots.forEach((slot, index) => {
      const div = document.createElement('div');
      div.className = `bundle-slot ${slot ? 'filled' : 'empty'}`;
      div.dataset.index = index;

      if (slot) {
        div.innerHTML = `
          <img src="${slot.image}" alt="${slot.color}">
          <span class="remove-slot">×</span>
          <div class="slot-label">${slot.color}<br>${slot.size}</div>
        `;
      } else {
        div.innerHTML = `<span class="slot-placeholder">${index + 1}</span>`;
      }
      els.slotsContainer.appendChild(div);
    });
  }

  function updateUI() {
    // Update Price
    const filledSlots = state.slots.filter(s => s !== null);
    const total = filledSlots.reduce((acc, curr) => acc + curr.price, 0);

    // Discount Logic
    let discountedTotal = total;
    let hasDiscount = false;

    if (state.bundleSizes && state.bundleDiscounts) {
      const sizeIndex = state.bundleSizes.indexOf(state.packSize);
      if (sizeIndex !== -1) {
        const discountObj = state.bundleDiscounts[sizeIndex];
        if (discountObj) {
          if (discountObj.type === 'percentage' && discountObj.value > 0) {
            discountedTotal = total * (1 - discountObj.value);
            hasDiscount = true;
          } else if (discountObj.type === 'fixed' && discountObj.value > 0) {
            // Apply discount proportionally based on current filling
            const proportion = filledSlots.length / state.packSize;
            discountedTotal = total - (discountObj.value * proportion);
            hasDiscount = true;
          }
        }
      }
    }

    if (hasDiscount && filledSlots.length > 0) {
      els.comparePriceDisplay.textContent = formatMoney(total);
      els.comparePriceDisplay.style.display = 'inline';
      els.totalPriceDisplay.textContent = formatMoney(discountedTotal);
    } else {
      els.comparePriceDisplay.textContent = '';
      els.comparePriceDisplay.style.display = 'none';
      els.totalPriceDisplay.textContent = formatMoney(total);
    }

    // Enable/Disable Add to Cart
    const isFull = filledSlots.length === state.packSize;
    els.addToCartBtn.disabled = !isFull;

    // Highlight incomplete
    if (!isFull) {
      els.errorMessage.textContent = `Select ${state.packSize - filledSlots.length} more pieces`;
    } else {
      els.errorMessage.textContent = '';
    }
  }

  function addToCart() {
    const filledSlots = state.slots.filter(s => s !== null);
    if (filledSlots.length !== state.packSize) return;

    els.addToCartBtn.classList.add('loading');
    els.addToCartBtn.textContent = 'Adding...';

    const items = filledSlots.map(slot => ({
      id: slot.variantId,
      quantity: 1
    }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(response => {
        if (response.ok) {
          // Success Feedback
          els.addToCartBtn.textContent = 'Added to Cart!';
          els.addToCartBtn.classList.remove('loading');

          // Optional: Trigger theme cart update events if they exist
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

          // Reset after a delay
          setTimeout(() => {
            els.addToCartBtn.textContent = 'Add To Cart';
            // Optionally clear slots or close modal here? User didn't ask, so keep state.
            closeModal();
          }, 2000);

        } else {
          return response.json().then(data => { throw new Error(data.description); });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        els.errorMessage.textContent = error.message;
        els.addToCartBtn.classList.remove('loading');
        els.addToCartBtn.textContent = 'Add To Cart';
      })
      .finally(() => {
        // Maybe open minicart?
      });
  }

  function formatMoney(cents) {
    var hasFraction = cents % 100 !== 0;
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD', // hardcoded for now, ideal to use Shopify currency
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  init();
});